export interface UserModel {
  id: number;
  name: string;
  img?: string;
  code?: string;
  email?: string;
  role?: string;
  status?: string;
  created_at?: string;
  updated_at?: string;
}

export interface UserAdapter {
  adapt(dto: any): UserModel;
}

export class UserBackendAdapter implements UserAdapter {
  adapt(dto: any): UserModel {
    return {
      id: dto.id,
      name: dto.name,
      img: dto.img ?? '',
      code: dto.key ?? '',
      email: dto.email ?? '',
      role: dto.role ?? '',
      status: dto.status ?? '',
      created_at: dto.created_at ?? '',
      updated_at: dto.updated_at ?? ''
    }
  }
}
